import { FileServiceApi } from 'api';
import useModal from 'hooks/useModal';
import { useAuthMutation } from 'queries/query';

function useUpload(directory?: string) {
  const { handleAlert } = useModal();
  const { mutateAsync } = useAuthMutation((file: File) =>
    FileServiceApi.upload(file, directory),
  );

  const handleUploadd = async (file: File) => {
    const validTypes = ['image/png', 'image/jpeg']; // jpeg은 MIME 타입이 image/jpeg
    const maxSizeInBytes = 1 * 1024 * 1024; // 1MB = 1024KB

    if (!validTypes.includes(file.type)) {
      handleAlert('지원하지 않는 파일 형식입니다.');
      return;
    }

    if (file.size > maxSizeInBytes) {
      handleAlert('파일 크기는 1MB 이하여야 합니다.');
      return;
    }

    return await mutateAsync(file);
  };

  return { handleUploadd };
}

export default useUpload;
